<template>
  <div class="logo">
    <router-link :to="{path:'/'}">
      <!-- <img style="width: 200px;height:32px" src="@/assets/images/logo.png" alt="logo" /> -->
      <tk-image :src="require('@/assets/images/logo.png')" width="133" height="22" :quality="100" style="bottom:-10px"></tk-image>
      <h1 v-if="showTitle">{{ projectName }}</h1>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
